import GameOptions from './GameOptions';

export default class SimpleTweenFloat {
	constructor(contextObject, startValue, endValue, time, updateCallBack, completeCallBack) {
		this.contextObject = contextObject;
		this.startValue = startValue;
		this.endValue = endValue;
		this.time = time;
		this.dTime = 0; // tween time  counter
		this.complete = false;
		this.val = startValue;
		this.updateCallBack = updateCallBack;
		this.completeCallBack = completeCallBack;
		this.delay = 0;
		this.valOld = this.val;
		GameOptions.simpleTweener.push(this);
	}

	update(deltaTime) {
		if (this.complete) return;
		this.dTime += deltaTime;
		if (this.dTime >= this.time) {
			this.dTime = this.time;
			this.valOld = this.val;
			this.val = this.endValue;
			this.updateCallBack.call(this.contextObject, this.val, this.val - this.valOld);
			this.completeCallBack.call(this.contextObject);
			this.complete = true;
		} else {
			this.valOld = this.val;
			this.val = this.lerp(this.startValue, this.endValue, this.dTime / this.time);
			this.updateCallBack.call(this.contextObject, this.val, this.val - this.valOld);
		}
	}

	lerp(val1, val2, amount) {
		amount = amount < 0.0 ? 0.0 : amount;
		amount = amount > 1.0 ? 1.0 : amount;
		return val1 + (val2 - val1) * amount;
	}
}
